module.exports = __webpack_public_path__ + "img/guria-pt-br.8fd561cf.png";